const buildSelector = (nthOfTypes: number[]) => {
  return nthOfTypes.map((nthOfType) => `& > path:nth-of-type(${nthOfType})`).join(', ');
};

export const chimeIconColorSelectorMap = {
  '#C9EBEC': buildSelector([1, 2, 3, 6, 9, 12, 13, 16, 19, 22]),
  '#00868C': buildSelector([4, 7, 10, 14, 17, 20, 23, 25]),
  '#00B3BB': buildSelector([5, 8, 11, 15, 18, 21, 24, 26]),
};
